import { render, staticRenderFns } from "./shareToMe.vue?vue&type=template&id=b97aa6c2"
import script from "./shareToMe.vue?vue&type=script&lang=ts"
export * from "./shareToMe.vue?vue&type=script&lang=ts"
import style0 from "./shareToMe.vue?vue&type=style&index=0&id=b97aa6c2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./shareToMe.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports